import type { StringIndexedObject } from '@kanda-libs/ks-component-ts';

/**
 * Handles error extraction from the error object
 */
export const getError = (error: StringIndexedObject<string>): string => {
  const { code } = error;

  if (code === 'auth/user-not-found')
    return 'User is not signed up with this email';
  if (code === 'auth/wrong-password')
    return 'Invalid user credentials provided';
  if (code === 'auth/popup-blocked')
    return 'Login popup blocked - allow popups or click the button again';
  if (code === 'auth/popup-closed-by-user')
    return 'Login popup close - please click the button again';

  return 'An error has occurred';
};

export const isStaff = (email: string) =>
  email.includes('@kanda.co.uk') ||
  email.includes('@idealsalessolutions') ||
  email.includes('@ideal4finance');
